import {
  OWNERSHIP_AREA_PERIMETER_SUMMARY_LAYER,
  OWNERSHIP_AREA_PERIMETER_SUMMARY_LAYER_US,
  OWNERSHIP_BUILDING_AREA_SUMMARY_LAYER_US,
} from "react-migration/layouts/map/Multilayer/layers/ownershipLayer";
import { PLANNING_APPLICATION_RECENT_SUMMARY_LAYER } from "react-migration/layouts/map/Multilayer/layers/planningApplicationLayer";
import {
  PROTECTED_LAND_SUMMARY_LAYER,
  SIGNIFICANT_CONSTRAINTS_FLOODING,
} from "react-migration/layouts/map/Multilayer/layers/significantConstraintsLayer";
import { DEMOGRAPHICS_SUMMARY_UK } from "react-migration/layouts/map/Multilayer/layers/demographicsLayerUK";
import { GREY_SUMMARY } from "react-migration/layouts/map/Multilayer/layers/greybeltLayer";
import { US_UTILITY_STATUS } from "react-migration/layouts/map/Multilayer/layers/usUtilitiesLayer";
import {
  COMPARABLES_LAYER_SUMMARY_US,
  HOMETRACK_LAYER_SUMMARY_SALE,
  HOMETRACK_LAYER_SUMMARY_RENTAL,
  LOCAL_MARKET_VALUE_LAYER_SUMMARY_UK,
} from "react-migration/layouts/map/Multilayer/layers/comparablesLayer";
import {
  LPA_LAYER_APPROVAL_RATE_SUMMARY,
  LPA_LAYER_PIF_SUMMARY,
} from "react-migration/layouts/map/Multilayer/layers/lpaLayer";
import { Layer } from "react-migration/layouts/map/Multilayer/types";
import {
  HAZARDS_FLOODING_SUMMARY,
  HAZARDS_WETLANDS_SUMMARY,
} from "react-migration/layouts/map/Multilayer/layers/hazardsLayer";
// import { DEMOGRAPHICS_SUMMARY_US } from "react-migration/layouts/map/Multilayer/layers/demographicsLayerUS";
import { ZONING_FLUM_SUMMARY } from "react-migration/layouts/map/Multilayer/layers/zoningLayer";
import { POWER_SUBSTATIONS } from "react-migration/layouts/map/Multilayer/layers/powerSubstationsLayer";
import { UK_AMENITIES, UK_CONNECTIVITY_SUMMARY } from "react-migration/layouts/map/Multilayer/layers/ukAmenitiesLayer";
import {
  TOPOGRAPHY_INSIGHT_ASPECT_SUMMARY,
  TOPOGRAPHY_INSIGHT_SLOPE_SUMMARY,
} from "react-migration/layouts/map/Multilayer/layers/topographyLayerUk";
import { UK_PROPERTY_INFORMATION_LAYER } from "react-migration/layouts/map/Multilayer/layers/ukPropertyInformationLayer";
import { LISTED_BUILDINGS_SUMMARY_LAYER } from "react-migration/layouts/map/Multilayer/layers/listedBuildings";
import { ENVIRONMENTAL_PERMITS_INSIGHTS_SUMMARY } from "react-migration/layouts/map/Multilayer/layers/environmentalPermitsLayer";
import { US_AMENITIES } from "react-migration/layouts/map/Multilayer/layers/usAmenitiesLayer";
import { ADOPTED_ROADS, TRAFFIC_COUNTS } from "react-migration/layouts/map/Multilayer/layers/roadAndTrafficLayer";

export const UK_INSIGHT_SUMMARY_LAYERS: Layer[] = [
  { ...OWNERSHIP_AREA_PERIMETER_SUMMARY_LAYER, excludeFromReport: true },
  UK_PROPERTY_INFORMATION_LAYER,
  { ...TOPOGRAPHY_INSIGHT_SLOPE_SUMMARY, excludeFromReport: true },
  { ...TOPOGRAPHY_INSIGHT_ASPECT_SUMMARY, excludeFromReport: true },
  PLANNING_APPLICATION_RECENT_SUMMARY_LAYER,
  LPA_LAYER_PIF_SUMMARY,
  LPA_LAYER_APPROVAL_RATE_SUMMARY,
  PROTECTED_LAND_SUMMARY_LAYER,
  GREY_SUMMARY,
  LISTED_BUILDINGS_SUMMARY_LAYER,
  SIGNIFICANT_CONSTRAINTS_FLOODING,
  UK_AMENITIES,
  UK_CONNECTIVITY_SUMMARY,
  LOCAL_MARKET_VALUE_LAYER_SUMMARY_UK,
  HOMETRACK_LAYER_SUMMARY_SALE,
  HOMETRACK_LAYER_SUMMARY_RENTAL,
  { ...DEMOGRAPHICS_SUMMARY_UK, excludeFromReport: true },
  ADOPTED_ROADS,
  TRAFFIC_COUNTS,
  POWER_SUBSTATIONS,
];

export const US_INSIGHT_SUMMARY_LAYERS: Layer[] = [
  { ...OWNERSHIP_AREA_PERIMETER_SUMMARY_LAYER_US, excludeFromReport: true },
  { ...OWNERSHIP_BUILDING_AREA_SUMMARY_LAYER_US, excludeFromReport: true },
  { ...ENVIRONMENTAL_PERMITS_INSIGHTS_SUMMARY, excludeFromReport: true },
  ZONING_FLUM_SUMMARY,
  HAZARDS_FLOODING_SUMMARY,
  HAZARDS_WETLANDS_SUMMARY,
  US_AMENITIES,
  US_UTILITY_STATUS,
  COMPARABLES_LAYER_SUMMARY_US,
  // { ...DEMOGRAPHICS_SUMMARY_US, excludeFromReport: true },
];
